export default __webpack_public_path__ + "static/44-cc2d1ed3b4aba359856c2f3e5e0be889.png";